import React                          from 'react';
import { Observe }                    from 'rewire-core';
import { WithStyle }                  from 'rewire-ui';
import Divider                        from '@material-ui/core/Divider';
import { Theme }                      from '../utility/styles';
import DraggableResizableDialog       from '../ui/DraggableResizableDialog';
import ViewTabs                       from '../ui/ViewTabs';
import { useWatch }                   from '../settings/SettingsModel';
import employeeViewTypeModel          from '../settings/EmployeeViewTypeModel';
import employeeEditorViewTabs         from '../settings/EmployeeEditorViewTabs';
import { EmployeeEditorContentsView } from '../settings/EmployeeEditorView';
import employeeDialogModel            from './EmployeeDialogModel';
import { withStyles }                 from '../utility/styles';

const styles = (_theme: Theme) => ({
  dialogChildrenContainer: {
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  employeeTabsContainer: {
    marginBottom: '10px',
  },
  employeeTabsDivider: {
    marginLeft: '-15px',
    marginRight: '-15px',
    marginBottom: '10px',
  },
});

interface IEmployeeDialogProps {
  classes?: any;
}

type EmployeeDialogProps = WithStyle<ReturnType<typeof styles>, IEmployeeDialogProps>;

export class EmployeeDialog extends React.PureComponent<EmployeeDialogProps> {
  componentWillUnmount() {
    employeeDialogModel.reset();
  }

  renderEmployeeTabs = React.memo((): JSX.Element => {
    const { classes } = this.props;

    return (
      < >
      <div className={classes.employeeTabsContainer}>
        <ViewTabs tabs={employeeEditorViewTabs} />
      </div>
      <Divider className={classes.employeeTabsDivider} />
      </>
    );
  });

  renderDialogContents = React.memo((): JSX.Element => {
    !employeeDialogModel.isNew && useWatch(
      () => {
        employeeViewTypeModel.view;
      },
      () => employeeDialogModel.loadView()
    );

    return <Observe render={() => (
      < >
      {!employeeDialogModel.isNew && <this.renderEmployeeTabs />}
      <EmployeeEditorContentsView model={employeeDialogModel} showBalances={!employeeDialogModel.isNew} />
      </>
    )} />;
  });

  render() {
    const { classes } = this.props;

    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='sm' classes={{childrenContainer: classes.dialogChildrenContainer}} DialogProps={{dialog: employeeDialogModel, actions: ['cancel', 'save']}} DraggableResizableBoxProps={{minWidth: '365px', minHeight: '525px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IEmployeeDialogProps>(styles, EmployeeDialog);
